export enum HeaderType {
  Standard,
  Collapsed,
}

export enum PortalId {
  DockedFooter = 'dockedFooter',
}
